import React from 'react';
import { Link } from 'react-router-dom';
const Banner = () => {
  return <div className="relative w-full h-[400px] md:h-[500px]" data-id="element-48">
      {/* Full-width background image */}
      <div className="absolute inset-0" data-id="element-49">
        <img src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Young entrepreneurs collaborating" className="w-full h-full object-cover" data-id="element-50" />
        {/* Dark overlay for better text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-navy/90 to-navy/70" data-id="element-51"></div>
      </div>
      {/* Content overlay */}
      <div className="container-custom relative h-full flex flex-col justify-center items-start" data-id="element-52">
        <div className="max-w-3xl" data-id="element-53">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 font-montserrat" data-id="element-54">
            Launch Your Business{' '}
            <span className="text-gold" data-id="element-55">Without the Learning Curve</span>
          </h1>
          <p className="text-lg md:text-xl text-white mb-8 max-w-2xl" data-id="element-56">
            Operation LaunchPad is a Non-Profit Consulting and Coaching
            Organization helping entrepreneurs build successful businesses. We
            provide the systems, strategies, and support you need to reach $1M+
            annual revenues.
          </p>
          <div className="flex flex-wrap gap-4" data-id="element-57">
            <Link to="/apply" className="bg-gold hover:bg-amber-500 text-navy font-bold py-3 px-8 rounded-md transition duration-300 text-lg" data-id="element-58">
              Apply Now
            </Link>
            <Link to="/programs" className="bg-transparent border-2 border-white hover:border-gold text-white hover:text-gold font-bold py-3 px-8 rounded-md transition duration-300 text-lg" data-id="element-59">
              Explore Programs
            </Link>
          </div>
        </div>
      </div>
    </div>;
};
export default Banner;